/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Fix_LockfileInputs */

const en_rd_fix_lockfile = /** @type {(inputs: Rd_Fix_LockfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commit the lockfile so the agent installs the exact versions you run.`)
};

const id_rd_fix_lockfile = /** @type {(inputs: Rd_Fix_LockfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commit lockfile-nya supaya agent memasang versi yang persis sama dengan punyamu.`)
};

/**
* | output |
* | --- |
* | "Commit the lockfile so the agent installs the exact versions you run." |
*
* @param {Rd_Fix_LockfileInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_fix_lockfile = /** @type {((inputs?: Rd_Fix_LockfileInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Fix_LockfileInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_fix_lockfile(inputs)
	return en_rd_fix_lockfile(inputs)
});